import { Button } from "@datamole/wds-component-button";
import { Card } from "@datamole/wds-component-card";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useContext } from "react";

import styles from "./entity-card.module.css";

import { InfoPopoverContext, NavEdgeTrigger } from "@/features/info-popover/popover.context";
import { navEdges, navPoints, commit } from "@/features/storage/data-provider";
import { storageService } from "@/features/storage/storage.service";
import { useStorageSubscription } from "@/features/storage/use-storage-subscription";

export const NavEdgeHeader = ({ trigger }: { trigger: NavEdgeTrigger }) => {
    const p1 = navPoints.find((p) => p.id === trigger.id1);
    const p2 = navPoints.find((p) => p.id === trigger.id2);

    return (
        <Card.Header.Description>
            <Card.Header.Description.Title style={{ fontSize: 20 }}>
                Nav Edge: {trigger.id1} ⇄ {trigger.id2}
            </Card.Header.Description.Title>
            <Card.Header.Description.Subtitle>
                {p1?.floorId === p2?.floorId ? `Floor: ${p1?.floorId}` : "Across floors"}
            </Card.Header.Description.Subtitle>
        </Card.Header.Description>
    );
};

export const NavEdgeCard = ({ trigger }: { trigger: NavEdgeTrigger }) => {
    useStorageSubscription();
    const p1 = navPoints.find((p) => p.id === trigger.id1);
    const p2 = navPoints.find((p) => p.id === trigger.id2);

    return (
        <div className={styles.card_info}>
            <div>
                <b>Point 1:</b> {p1 ? `${p1.id} (${p1.location.x}, ${p1.location.y})` : "Unknown"}
            </div>
            <div>
                <b>Point 2:</b> {p2 ? `${p2.id} (${p2.location.x}, ${p2.location.y})` : "Unknown"}
            </div>
        </div>
    );
};

export const NavEdgeActions = ({ trigger }: { trigger: NavEdgeTrigger }) => {
    const { setTrigger } = useContext(InfoPopoverContext);

    const handleDelete = () => {
        const idx = navEdges.findIndex(
            (e) => (e.id1 === trigger.id1 && e.id2 === trigger.id2) || (e.id1 === trigger.id2 && e.id2 === trigger.id1),
        );
        if (idx >= 0) {
            navEdges.splice(idx, 1);
            commit();
            storageService.notifySubscribers({ type: "nav-edge-removed", id1: trigger.id1, id2: trigger.id2 });
        }
        setTrigger(null);
    };

    return (
        <Button variant="outline" onClick={handleDelete}>
            <Button.Icon>
                <FontAwesomeIcon icon={faTrash} />
            </Button.Icon>
            <Button.Content>Delete Edge</Button.Content>
        </Button>
    );
};
